import { DateTime } from 'luxon';
import { z } from 'zod';
import { assignmentRequestSchema } from '../form/use-save-assignment-form';
// account type
export var AutoAssignType;
(function (AutoAssignType) {
    AutoAssignType["NONE"] = "NONE";
    AutoAssignType["FIXED"] = "FIXED";
    AutoAssignType["TARGET"] = "TARGET";
})(AutoAssignType || (AutoAssignType = {}));
export const autoAssignTypeSchema = z.nativeEnum(AutoAssignType);
// auto assign request
export const autoAssignRequestSchema = z.object({
    type: autoAssignTypeSchema.optional(),
    amount: z.coerce.number().optional(),
    month: z.number().min(1).max(12).optional(),
    year: z
        .number()
        .min(DateTime.now().year - 1)
        .max(DateTime.now().year + 10)
        .optional(),
    recurrenceMonths: z.string().optional(),
    topOff: z.boolean().optional(),
    disabled: z.boolean().optional(),
});
// auto assign
export const autoAssignSchema = z.object({
    type: autoAssignTypeSchema.optional(),
    amount: z.coerce.number().optional(),
    target: z.string().nullish(),
    recurrenceMonths: z.coerce.number().optional(),
    topOff: z.boolean().optional(),
    disabled: z.boolean().optional(),
});
// bucket request
export const bucketRequestSchema = z.object({
    id: z.string(),
    budgetId: z.string().uuid(),
    categoryId: z.string().uuid().optional(),
    name: z.string(),
    notes: z.string().optional(),
    position: z.number(),
    archived: z.boolean().optional(),
    favorite: z.boolean().optional(),
    assignments: assignmentRequestSchema.array(),
    autoAssign: autoAssignSchema.optional(),
});
// bucket
export const bucketSchema = bucketRequestSchema.extend({});
// bucket sort
export const bucketRequestSortSchema = z.object({
    budgetId: z.string().uuid(),
    ids: z.array(z.string().uuid()),
});
// bucket delete
export const bucketDeleteSchema = z.object({
    budgetId: z.string().uuid(),
    id: z.string().uuid(),
});
